<template>
  <card title="project" v-loading="loading.project">
    <el-form label-position="left" label-width="250px" size="small">
      <el-form-item label="Created at">
        <div class="block">
          <el-date-picker v-model="payload.created_at" type="datetime">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="Name">
        <el-input v-model="payload.name" />
      </el-form-item>
      <el-form-item label="Components count">
        <el-input-number
          v-model="payload.components_count"
          :min="0"
          :step="1"
          step-strictly
        />
      </el-form-item>
      <el-form-item label="Domain">
        <el-input v-model="payload.subdomain" />
      </el-form-item>
      <el-form-item label="Drafts count">
        <el-input-number
          v-model="payload.drafts_count"
          :min="0"
          :step="1"
          step-strictly
        />
      </el-form-item>
      <el-form-item label="Export code count">
        <el-input-number
          v-model="payload.export_code_count"
          :min="0"
          :step="1"
          step-strictly
        />
      </el-form-item>
      <el-form-item label="Archived">
        <el-switch v-model="payload.is_archived" />
      </el-form-item>
      <el-form-item label="Locked">
        <el-switch v-model="payload.is_locked" />
      </el-form-item>
      <el-form-item label="Enable SSL">
        <el-switch v-model="payload.is_force_ssl" />
      </el-form-item>
      <el-form-item label="Meta enabled facebook">
        <el-switch v-model="payload.is_meta_enabled_facebook" />
      </el-form-item>
      <el-form-item label="Meta enabled twitter">
        <el-switch v-model="payload.is_meta_enabled_twitter" />
      </el-form-item>
      <el-form-item label="Overrides enabled">
        <el-switch v-model="payload.is_overrides_enabled" />
      </el-form-item>
      <el-form-item label="Published">
        <el-switch v-model="payload.is_published" />
      </el-form-item>
      <el-form-item label="Syncing">
        <el-switch v-model="payload.is_syncing" />
      </el-form-item>
      <el-form-item label="White label">
        <el-switch v-model="payload.is_white_label" />
      </el-form-item>
      <el-form-item label="Latest release plugin version">
        <el-input v-model="payload.latest_release_plugin_version" />
      </el-form-item>
      <!-- <el-form-item label="Latest synced project release">
        <el-input v-model="payload.latest_synced_project_release" />
      </el-form-item>
      <el-form-item label="Live project release">
        <el-input v-model="payload.live_project_release" />
      </el-form-item> -->
      <el-form-item label="Live project release homepage slug">
        <el-input v-model="payload.live_project_release_homepage_slug" />
      </el-form-item>
      <el-form-item label="Page names">
        <el-select
          v-model="payload.page_names"
          multiple
          filterable
          allow-create
          default-first-option
        >
          <el-option
            v-for="(item, index) in payload.page_names"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Project members count">
        <el-input-number
          v-model="payload.project_members_count"
          :min="0"
          :step="1"
          step-strictly
        />
      </el-form-item>
      <el-form-item label="Revision count">
        <el-input-number
          v-model="payload.revision_count"
          :min="0"
          :step="1"
          step-strictly
        />
      </el-form-item>
      <el-form-item label="Short ID">
        <el-input v-model="payload.short_id" />
      </el-form-item>
      <el-form-item label="Webhooks URLS">
        <el-select
          v-model="payload.webhooks_urls"
          multiple
          filterable
          allow-create
          default-first-option
        >
          <el-option
            v-for="(item, index) in payload.webhooks_urls"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="Similar screens ID">
        <el-select
          v-model="payload.similar_screens_id"
          multiple
          filterable
          allow-create
          default-first-option
        >
          <el-option
            v-for="(item, index) in payload.similar_screens_id"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="Slug">
        <el-input v-model="payload.slug" />
      </el-form-item>
      <el-form-item label="Team name">
        <el-input v-model="payload.team_name" readonly />
      </el-form-item>
      <el-form-item label="Team slug">
        <el-input v-model="payload.team_slug" />
      </el-form-item>
      <el-form-item label="Thumb URL">
        <el-input v-model="payload.thumb_url" readonly />
        <el-button
          @click="onCopy(payload.thumb_url)"
          icon="el-icon-document-copy"
          >Copy</el-button
        >
      </el-form-item>
      <el-form-item
        label="Canary download url web"
        v-loading="loading.projectRelease"
      >
        <el-input v-model="payload.canary_download_url_web" readonly />
        <el-button
          @click="onCopy(payload.canary_download_url_web)"
          icon="el-icon-document-copy"
          >Copy</el-button
        >
      </el-form-item>
      <el-form-item label="Download url web" v-loading="loading.projectRelease">
        <el-input v-model="payload.download_url_web" readonly />
        <el-button
          @click="onCopy(payload.download_url_web)"
          icon="el-icon-document-copy"
          >Copy</el-button
        >
      </el-form-item>
      <el-form-item label="Updated at">
        <div class="block">
          <el-date-picker v-model="payload.updated_at" type="datetime">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="Actions">
        <el-button @click="save" type="primary">Save</el-button>
        <el-button @click="clearCache">Clear server image cache</el-button>
        <el-link :href="projectUrl" target="_blank">Open in Anima</el-link>
        <el-link :href="sourceUrl" target="_blank" v-if="sourceUrl"
          >Open in Figma</el-link
        >
        <div class="confirm-buttons">
          <Confirm @confirm="restore" v-if="payload.is_deleted">
            <el-button type="success">Restore</el-button>
          </Confirm>
        </div>
      </el-form-item>
    </el-form>
  </card>
</template>

<script>
import { pick } from "lodash";
import { mapGetters, mapActions } from "vuex";
import Card from "@/components/Card";
import copy from "@/utils/copy";
import Confirm from "@/components/Confirm";

export default {
  data() {
    return {
      payload: {},
      sourceUrl: null,
    };
  },
  props: {
    project: Object,
    projectRelease: Object,
  },
  components: {
    Card,
    Confirm,
  },
  async mounted() {
    this.payload = { ...this.project };
    if (this.projectRelease) {
      await this.checkSourceURL();
    }
  },
  computed: {
    ...mapGetters(["loading"]),
    projectUrl() {
      return `https://projects.animaapp.com/p/${this.payload.short_id}`;
    },
    pageNames: {
      get() {
        return this.payload.page_names;
      },
    },
  },
  methods: {
    ...mapActions(["updateProject", "getProject"]),
    onCopy(value) {
      copy(value);
      this.$notify.success("Copied successfully!");
    },
    async checkSourceURL() {
      if (this.projectRelease?.model_url) {
        const resp = await fetch(this.projectRelease.model_url);
        const body = await resp.json();
        this.sourceUrl = body.figma_file_id
          ? `https://www.figma.com/file/${body.figma_file_id}`
          : null;
      }
    },
    async saveChanges(payload) {
      try {
        const { id } = this.project;
        await this.updateProject({ id, payload });
        this.$notify.success("Changes saved successfully!");
        this.getProject(id);
      } catch (e) {
        this.$notify.error({
          title: "Failed saving changes",
          message: e.message,
        });
      }
    },
    forceSSL() {
      const { project } = this;
      return this.saveChanges({ is_force_ssl: project.is_force_ssl });
    },
    async clearCache() {
      try {
        const { project } = this;
        await this.$api.post(`/cs/projects/${project.id}/delete_registry`);
        this.$notify.success("Cache cleared successfully!");
      } catch (e) {
        this.$notify.error({
          title: "Failed clearing cache",
          message: e.message,
        });
      }
    },
    async save() {
      try {
        const { id } = this.project;
        const payload = pick(this.payload, [
          "created_at",
          "name",
          "components_count",
          "subdomain",
          "drafts_count",
          "export_code_count",
          "is_archived",
          "is_locked",
          "is_force_ssl",
          "is_meta_enabled_facebook",
          "is_meta_enabled_twitter",
          "is_overrides_enabled",
          "is_published",
          "is_syncing",
          "is_white_label",
          "latest_release_plugin_version",
          // "latest_synced_project_release",
          // "live_project_release",
          "live_project_release_homepage_slug",
          "page_names",
          "project_members_count",
          "revision_count",
          "short_id",
          "webhooks_urls",
          // "similar_screens_id",
          "slug",
          "team_name",
          "team_slug",
          "thumb_url",
          "canary_download_url_web",
          "download_url_web",
          "updated_at",
        ]);
        await this.updateProject({ id, payload });
        this.$notify.success("Changes saved successfully!");
      } catch (e) {
        this.$notify.error({
          title: "Failed saving changes",
          message: e.message,
        });
      }
    },
  },
  watch: {
    project(newValue) {
      this.payload = { ...newValue };
    },
    projectRelease() {
      this.checkSourceURL();
    },
  },
};
</script>

<style scoped></style>
